// Detect outside click of an element

function nodeContainsId(el, id) {
    if (el.id === id) {
        return true;
    }

    let current = el.parentNode;

    while (current && current !== document) {
        if (current.id === id) {
            return true;
        }
        current = current.parentNode;
    }

    return false;
}

// Menus currently open (an attached clickOutside = an open menu): the map reads it at click time,
// before the click bubbles here and closes the menu, so that click adds no point.
const openMenus = new Set();

export const hasOpenMenu = () => openMenus.size > 0;

// For menus with their own outside-click action; close: how to close it (closeOpenMenus).
// Returns the release function (idempotent).
export const trackOpenMenu = (close) => {
    const menu = {close};
    openMenus.add(menu);

    return () => {
        openMenus.delete(menu);
    };
};

// For a click that never reaches document.body (a POI marker stops it): close the menus directly.
export const closeOpenMenus = () => {
    [...openMenus].forEach((menu) => menu.close?.());
};

// Flowbite dropdowns ({onShow, onHide} options): they close in the capture phase, before the map
// hears the click, so the release waits for the next task. Idempotent: flowbite fires both hooks
// even when the state does not change.
export const openMenuHooks = () => {
    let release = null;

    return {
        onShow: (dropdown) => {
            // Already hidden (closed in capture) or destroyed (MapToolbar teardown): leave it alone
            release ||= trackOpenMenu(() => dropdown?.isVisible() && dropdown.hide());
        },
        onHide: () => {
            if (!release) {
                return;
            }

            const pending = release;
            release = null;
            setTimeout(pending, 0);
        }
    };
};

// callbackFunction: called when click outside
// triggerId: element triggering the dropdown
// countsAsMenu: false for an overlay that a map click must still reach (the section palette)
export const clickOutside = (callbackFunction, triggerId, {countsAsMenu = true} = {}) => {
    return (element) => {
        function onClick(event) {
            let isTriggerClick = false;
            if (nodeContainsId(event.target, triggerId)) {
                isTriggerClick = true;
            }

            if (!element.contains(event.target) && !isTriggerClick) {
                callbackFunction(event.target);
            }
        }

        document.body.addEventListener('click', onClick);
        const releaseMenu = countsAsMenu ? trackOpenMenu(() => callbackFunction()) : () => {};

        return () => {
            document.body.removeEventListener('click', onClick);
            releaseMenu();
        };
    };
};
